import { api } from '..';
import {
  ExportItemsQueryParams,
  ExportItemsResponseBody,
} from '../../../shared/types/export';

type ExportItemsFnParams = Omit<ExportItemsQueryParams, 'columns'> & {
  columns: string[];
  fileName?: string;
};

export const exportItems = async ({
  columns = [],
  fileName = '',
  industry,
}: ExportItemsFnParams): Promise<boolean> => {
  try {
    const response = await api.get<ExportItemsResponseBody>(
      `/export/items`,
      {
        params: {
          columns: columns.join(','),
          industry,
        },
        responseType: 'arraybuffer',
      },
    );
    const fileURL = window.URL.createObjectURL(
      new Blob([response.data]),
    );
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute(
      'download',
      `${fileName || 'hinnastotyökalu-tuotteet'}.xlsx`,
    );
    link.click();
    return true;
  } catch (e) {
    console.error(`Failed to download items XLSX: ${e}`);
    return false;
  }
};
